import React, {useEffect, useRef, useState} from "react";
import {Breadcrumbs} from "@mui/material";
import {useDeliveryStore} from "@/Stores/Site/DeliveryStore";
import {useLocationStore} from "@/Stores/Site/LocationStore";
import {declOfNum, scrollToElement} from "@/Helpers/Function";
import BaseLayout from "@/Layouts/BaseLayout";
import Svg from "@/Components/Svg";
import Link from "@/Layouts/Link";
import Picture from "@/Components/Picture";
import "@/Pages/Delivery/scss/index.scss";

const Index = (props) => {
    const {
        mobileApp = false,
        city,
        imgVersion = '',
        deliveryInformation = {},
        paymentMethods = []
    } = props;

    const {brandShopCount = 0, pvzCount = 0} = deliveryInformation;

    const openModalDeliveryInformation = useDeliveryStore(state => state.openModalDeliveryInformation);
    const openModalSelectCity = useLocationStore(state => state.openModalSelectCity);

    let shippingMethodsClass;
    if (brandShopCount !== 0) {
        shippingMethodsClass = 'paymentDelivery-shippingMethods__item paymentDelivery-shippingMethods__item_third';
    } else {
        shippingMethodsClass = 'paymentDelivery-shippingMethods__item paymentDelivery-shippingMethods__item_half';
    }

    if (pvzCount === 0) {
        shippingMethodsClass = 'paymentDelivery-shippingMethods__item paymentDelivery-shippingMethods__item_full';
    }

    // Способы оплаты
    const paymentMethodsList = paymentMethods.map((el, i) => {
        const {iconName = '', title = '', description = '', link = ''} = el;

        return (
            <div key={i} className={`paymentDelivery-paymentMethods__item`}>
                <div className={`paymentDelivery-paymentMethods__icon`}>
                    <Svg id={iconName} className={`svg__${iconName}`} />
                </div>
                <p className={`paymentDelivery-paymentMethods__subTitle`}>
                    {title}
                </p>
                <p className={`paymentDelivery-paymentMethods__description`}>
                    {description}
                </p>
                {link !== '' && (
                    <Link href={link} className={`paymentDelivery-paymentMethods__link`}>Подробнее</Link>
                )}
            </div>
        );
    });

    return (
        <BaseLayout {...props}>
            <section className={`section`}>
                {!mobileApp && (
                    <div className={`container`}>
                        <Breadcrumbs maxItems={2} itemsAfterCollapse={2} className={`breadcrumbs`}>
                            <Link className={`breadcrumbs__link`} href={`/`}>Главная</Link>
                            <p className={`breadcrumbs__text`}>Оплата и доставка</p>
                        </Breadcrumbs>
                    </div>
                )}
                <div className={`paymentDelivery`}>
                    <div className={`container`}>
                        <div className={`paymentDelivery-main`}>
                            <div className={`paymentDelivery-main__content`}>
                                <h1 className={`h1 h1__paymentDelivery`}>Оплата и доставка</h1>
                                <p className={`paymentDelivery-main__text`}>
                                    Мы всегда стараемся сделать <span
                                    className={`paymentDelivery-main__text_bold`}> оформление заказа максимально удобным</span> для
                                    вас, поэтому <span className={`paymentDelivery-main__text_bold`}> предлагаем различные варианты оплаты и доставки,</span> чтобы
                                    вы смогли выбрать наиболее подходящий.
                                </p>
                                <p className={`paymentDelivery-main__text`}>
                                    Доставка заказов осуществляется по&nbsp;территории Российской Федерации, Республики
                                    Беларусь и&nbsp;Республики Казахстан.
                                </p>
                                <div className={`paymentDelivery-city`}>
                                    <p className={`paymentDelivery-city__select`}>
                                        Выберите ваш город&nbsp;
                                        <span className={`paymentDelivery-city__selectedCity`}
                                              onClick={openModalSelectCity}>
                                        {city}
                                    </span>
                                    </p>
                                    {/*<p className={`paymentDelivery-city__resultText`}>Вам доступны:</p>*/}
                                </div>
                            </div>
                            <div className={`paymentDelivery-main__banner`}>
                                <Picture
                                    src={`/storage/img/delivery/delivery_banner.png?v=${imgVersion}`}
                                    alt={`deliveryBanner`}
                                />
                            </div>
                        </div>
                    </div>
                    <div className={`container`}>
                        <div className={`paymentDelivery-paymentMethods`}>
                            <p className={`paymentDelivery__title`}>Способы оплаты:</p>
                            <div className={`paymentDelivery-paymentMethods__body`}>{paymentMethodsList}</div>
                        </div>
                        <div className={`paymentDelivery-shippingMethods`}>
                            <p className={`paymentDelivery__title`}>Способы доставки:</p>
                            <div className={`paymentDelivery-shippingMethods__body`}>
                                <div className={shippingMethodsClass}>
                                    <Svg id={`deliveryByCourier`} className={`svg__deliveryByCourier`} />
                                    <p className={`paymentDelivery-shippingMethods__subTitle`}>
                                        Курьером до&nbsp;двери
                                    </p>
                                </div>
                                {brandShopCount !== 0 && (
                                    <div className={shippingMethodsClass}>
                                        <Svg id={`deliveryToStore`} className={`svg__deliveryToStore`} />
                                        <p className={`paymentDelivery-shippingMethods__subTitle`}>
                                            В <span className={`paymentDelivery__brandShopСount`}
                                                    onClick={() => openModalDeliveryInformation('brandShop')}>
                                                        {brandShopCount}
                                            &nbsp;
                                            {declOfNum(brandShopCount, ['магазине', 'магазинах', 'магазинах'])}
                                                        </span> PLATINA
                                        </p>
                                    </div>
                                )}
                                {pvzCount !== 0 && (
                                    <div className={shippingMethodsClass}>
                                        <Svg id={`deliveryToPvz`} className={`svg__deliveryToPvz`} />
                                        <p className={`paymentDelivery-shippingMethods__subTitle`}>
                                            В <span className={`paymentDelivery__pvzCount`}
                                                    onClick={() => openModalDeliveryInformation('pvz')}>
                                                        {pvzCount}
                                            &nbsp;
                                            {declOfNum(pvzCount, ['пункте', 'пунктах', 'пунктах'])}
                                                    </span> выдачи
                                        </p>
                                    </div>
                                )}
                            </div>
                        </div>
                        <FaqComponent {...props} />
                        <p className={`paymentDelivery-footnote`}>
                            Более подробную информацию об условиях доставки и оплаты заказов вы можете получить
                            у ювелирного консультанта при оформлении заказа либо ознакомиться с соответствующими
                            разделами
                            <Link href={`/rule/dogovor-publichnoj-oferty`}
                                  className={`link link__bold link__pdf`}>
                                &nbsp;договора оферты
                            </Link>.
                            {/*<a href="/storage/docs/dogovor_publichnoy_oferti.pdf"*/}
                            {/*   className={`link link__bold link__pdf`}*/}
                            {/*   target={`_blank`}>*/}
                            {/*    &nbsp;договора оферты.*/}
                            {/*</a>*/}
                        </p>
                    </div>
                </div>
            </section>
        </BaseLayout>
    );
}

/**
 * Часто задаваемые вопросы
 * @param props
 * @returns {JSX.Element|null}
 * @constructor
 */
const FaqComponent = (props) => {
    const {faqList = []} = props;

    // Запоминаем какой раздел нужно открыть, если перешли по hash ссылке на страницу
    const [sectionIdOpen, setSectionIdOpen] = useState();

    // Создаем объект для хранения ref ссылок
    const refs = useRef({});

    const [faqState, setFaqState] = useState(() => {
        const state = {};
        faqList.forEach(el => {
            state[`faq_${el.id}`] = false;
        });
        return state;
    });

    // Создаем refs на основе hash поля данных
    useEffect(() => {
        faqList.forEach(item => {
            if (item.hash) {
                refs.current[item.hash] = React.createRef();
            }
            if (location.hash !== '' && item.hash === location.hash.replace("#", "")) {
                setSectionIdOpen(item.id);
            }
        });
    }, [faqList]);

    /**
     * Переключение аккордион
     * @param id
     */
    const toggleFaq = (id) => {
        setFaqState(state => ({...state, [`faq_${id}`]: !state[`faq_${id}`]}));
    }

    const element = faqList.map((el) => {
        const {id, question = '', answer = '', hash = ''} = el;

        return <div key={id} ref={refs.current[hash]} className={`paymentDelivery-faq__item`}>
            <div className={`paymentDelivery-faq__questionContainer`} onClick={() => toggleFaq(id)}>
                <p className={`paymentDelivery-faq__question`}>{question}</p>
                <Svg id={`keyboardArrowDownOutlinedIcon`}
                     className={`svg__splitFaqArrow${faqState[`faq_${id}`] ? ' svg__splitFaqArrow_up' : ''}`} />
            </div>
            <div className={`paymentDelivery-faq__answerContainer${faqState[`faq_${id}`] ? ' visible' : ''}`}>
                <div className={`paymentDelivery-faq__answer`} dangerouslySetInnerHTML={{__html: answer}}></div>
            </div>
        </div>
    });

    useEffect(() => {
        if (location.hash !== '') {
            const options = {block: "start", inline: "center", behavior: "smooth"};
            setTimeout(() => {
                scrollToElement(refs.current[location.hash.replace("#", "")].current, options);
                setFaqState(state => ({...state, [`faq_${sectionIdOpen}`]: !state[`faq_${sectionIdOpen}`]}));
            }, 100);
        }
    }, [location.hash, sectionIdOpen]);

    if (faqList.length === 0) return null;

    return <div className={`paymentDelivery-faq`}>
        <p className={`paymentDelivery-faq__title`}>Часто задаваемые вопросы</p>
        <div className={`paymentDelivery-faq__body`}>
            {element}
        </div>
    </div>
}

export default Index;

